import React from "react";
import { motion } from "framer-motion";

/**
 * FadeSlide Transition
 * - Fast and elegant for standard page changes
 * - Current page: fades out + slides left
 * - New page: fades in + slides from right
 * - Duration: 300ms
 */

const FadeSlide = ({ children, isReady }) => {
  return (
    <motion.div
      className="page-transition-container"
      initial={{
        opacity: 0,
        x: 40,
        filter: "blur(4px)"
      }}
      animate={{
        opacity: isReady ? 1 : 0.8,
        x: 0,
        filter: "blur(0px)"
      }}
      exit={{
        opacity: 0,
        x: -40,
        filter: "blur(4px)"
      }}
      transition={{
        duration: 0.3,
        ease: [0.4, 0, 0.2, 1], // Custom easing for smooth feel
        opacity: { duration: 0.25 },
        x: { duration: 0.3 },
        filter: { duration: 0.2 }
      }}
    >
      {children}
    </motion.div>
  );
};

export default FadeSlide;
